export const getProviderApiKey = (settings = {}, provider) => {
  if (!provider || provider === "ollama") return "";

  const activeKey =
    settings.provider === provider && typeof settings.apiKey === "string"
      ? settings.apiKey
      : "";
  const storedKey = settings.apiKeys?.[provider];

  return (activeKey || storedKey || "").trim();
};

export const getReadyProviderOptions = (settings = {}, providers = {}) => {
  return Object.entries(providers)
    .map(([key, config]) => ({
      key,
      label: config.label || key,
      isLocal: Boolean(config.isLocal),
      readyNow:
        !config.apiKeyRequired || Boolean(getProviderApiKey(settings, key)),
    }))
    .filter((provider) => provider.readyNow);
};

export const getQuickSwitchModels = ({
  provider,
  providers = {},
  localModels = [],
  currentSettings = {},
}) => {
  const config = providers[provider];
  if (!config) return [];

  if (provider === "ollama") {
    const currentModel =
      currentSettings.provider === provider ? currentSettings.model : "";

    return Array.from(new Set([currentModel, ...localModels].filter(Boolean)));
  }

  return Array.isArray(config.models) ? config.models : [];
};

export const getNextQuickSwitchModel = ({
  provider,
  providers = {},
  localModels = [],
  currentSettings = {},
}) => {
  const models = getQuickSwitchModels({
    provider,
    providers,
    localModels,
    currentSettings,
  });
  const config = providers[provider];

  if (
    currentSettings.provider === provider &&
    currentSettings.model &&
    models.includes(currentSettings.model)
  ) {
    return currentSettings.model;
  }

  return models[0] || config?.defaultModel || "";
};